import { DevelopmentFeatureFlags, PracticeFeatureFlags, useFeature } from "@/feature-flags";

/**
 * Whether the charge-capture billing pipeline UI is enabled (practice Billing +
 * development Practice Billing flags), matching Practice Billing nav gating.
 */
export function useBillingPipelineFeature(): boolean {
  const isBillingEnabled = useFeature(PracticeFeatureFlags.Billing);
  const isPracticeBillingEnabled = useFeature(DevelopmentFeatureFlags.PracticeBilling);
  return isBillingEnabled && isPracticeBillingEnabled;
}
